<div class="container" [ngClass]="{'no-margin': !margin}">
  <ng-content></ng-content>
</div>
